export default __webpack_public_path__ + "static/media/survey.0dcdd2d2.svg";